import { ApigetServerTime, ApigetPageconfig } from '@/service'

export default {
    namespaced: true,
    state: {
        serviceTime: 0,
        //服务器时间计时器
        serviceTimer: null,
        appConfig: {}, // 配置
        siteConfig:{},
    },
    mutations: {
        setServiceTime(state, date) {
            state.serviceTime = date
        },
        clearServiceTimer(state) {
            console.log('清除服务器时间计时器')
            clearInterval(state.serviceTimer)
            state.serviceTimer = null;
        },
        setAppConfig(state, date) {
            state.appConfig = date;
        },
        setSiteConfig(state, date) {
            state.siteConfig = date;
        }
    },
    actions: {
        getServiceTime({ commit, dispatch, state }, isClear = true) {
            return new Promise((resolve, reject) => {
                ApigetServerTime().then(res => {
                    if (res.code == '12200') {
                        let TimezoneOffset = new Date().getTimezoneOffset() - -480;
                        let LocalTime = res.data + (TimezoneOffset * 60 * 1000)
                        commit('setServiceTime', LocalTime)
                        if (isClear) {
                            clearInterval(state.serviceTimer)
                            state.serviceTimer = setInterval(() => {
                                commit('setServiceTime', state.serviceTime += 1000)
                            }, 1000);
                        }
                        resolve(res)
                    }
                    reject(res)
                })
            })
        },
        // 获取配置
        getPageconfig({ commit, dispatch, state }) {
            return new Promise(async (resolve, reject) => {
                const RES = await ApigetPageconfig();
                if (RES.code == '12200') {
                    let config = {}
                    let siteConfig = {};
                    console.log(RES)
                    try {
                        RES.data.forEach((c, index) => {
                            if (c.configKey == "open_prize_web_config") {
                                config = JSON.parse(c.configValue)
                            }
                            if(c.configKey == "site_config"){
                                siteConfig = JSON.parse(c.configValue)
                            }
                        });
                        commit('setAppConfig', config);
                        commit('setSiteConfig', siteConfig);
                        const ico = Object.keys(config).length > 0
                            ? siteConfig.ico
                            : 'https://qny-zhzy.mcjdzsw.top/LOTTERYOPEN/favicon.ico'
                        //设置ico
                        const links = document.createElement('link')
                        links.setAttribute('href', ico)
                        links.setAttribute('rel', 'shortcut icon')
                        document.getElementsByTagName('head')[0].appendChild(links)
                        // 设置title
                        document.title = config.short_name || '开奖网'
                        resolve(RES.data)
                    } catch (e) {
                        console.warn(e)
                    }
                }
                resolve(RES)
            })
        },
    },
    getters: {
        getServiceTime(state) {
            if (state.serviceTimer == null) {
                return 0;
            } else {
                return state.serviceTime
            }
        }
    }
}